
module.config(function($httpProvider) {
    // $httpProvider.interceptors.push(function($injector, $q) {
    //     return {
    //         responseError: function(rejection) {
    //             var httpErrors = [500, 404];
    //             var $state = $injector.get('$state');

    //             if (httpErrors.indexOf(rejection.status) != -1) {
    //                 $state.go('error', {
    //                     statusCode: rejection.status,
    //                     data: rejection.data,
    //                 });
    //             }
    //             return $q.reject(rejection);
    //         },
    //     };
    // });
});